// src/utils/sessions.js

const STORAGE_KEY = 'ai_chat_sessions'

export function getSessions() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []
  } catch {
    return []
  }
}

export function saveSessions(sessions) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(sessions))
}

export function createSession() {
  const id =
    window.crypto?.randomUUID?.() ||
    Date.now().toString() + '-' + Math.random().toString(36).slice(2)
  const newSession = { id, title: 'New Chat', createdAt: Date.now() }
  const all = [newSession, ...getSessions()]
  saveSessions(all)
  return newSession
}
